import './modules/LiteVimeo'
import Highway from '@dogstudio/highway'
import { getViewportHeight, debounce } from './libs/dom'

import 'large-small-dynamic-viewport-units-polyfill'

import Scroller from './modules/Scroller'
import ImgLoaded from './modules/ImagesLoaded'
import Cookie from './modules/Cookie'
import Navigation from './modules/Navigation'

import Fade from './modules/Transitions'
import DefaultRenderer from './modules/DefaultRenderer'

const onResize = () => {
  requestAnimationFrame(getViewportHeight)
}

const onPageChange = () => {
  activeLinks()
  new ImgLoaded()
}

const activeLinks = () => {
  const links = document.querySelectorAll('.c-header__left .menu a')

  for (let i = 0; i < links.length; i += 1) {
    const link = links[i]
    const href = link.href.endsWith('/') ? link.href : `${link.href}/`
    const currentHref = window.location.href.endsWith('/')
      ? window.location.href
      : `${window.location.href}/`

    const parentLink = link.closest('li')

    if (href === currentHref) {
      parentLink?.classList.add('current-menu-item')
      link.setAttribute('aria-current', 'page')
    } else {
      parentLink?.classList.remove('current-menu-item')
      link.removeAttribute('aria-current')
    }
  }
}

const onLoad = () => {
  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: Fade,
    },
  })

  H.on('NAVIGATE_IN', onPageChange)

  window.H = H

  new Navigation()
  new Scroller()
  new Cookie()
  onPageChange()
  getViewportHeight()
}

const debouncedResize = debounce(onResize, 100)
document.addEventListener('DOMContentLoaded', onLoad)
window.addEventListener('resize', debouncedResize)
